import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const SidebarItemSociete = ({ item }) => {
    let location = useLocation();
        return (
          <Link to={item.path || '#'} title={item.title} className={location.pathname === item.path ? 'sidebar-item active' : 'sidebar-item '}>
            <div className='sidebar-title'>
              <span>
                <i className={item.icon}></i>
                {item.title}
              </span>
            </div>
          </Link>
        )
      }


export default SidebarItemSociete